import { graphql } from '@guuru/graphql-common/gql';

const GET_CHAT = graphql(`
  query GetChatWaitTimeout($id: ID!) {
    chat(id: $id) {
      id
      status
    }
  }
`);

export default GET_CHAT;
